import React, { useState } from 'react';
import { BiLink, BiImage } from 'react-icons/bi';
import './Chat.css';

export default function ChatImage({ src, alt = 'Attachment' }) {
  const [showActions, setShowActions] = useState(false);
  const [copied, setCopied] = useState(null);

  const handleCopyLink = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(src);
      setCopied('link');
      setTimeout(() => setCopied(null), 1500);
    } catch {
      setCopied(null);
    }
  };

  const handleCopyImage = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const res = await fetch(src, { mode: 'cors' });
      const blob = await res.blob();
      await navigator.clipboard.write([
        new ClipboardItem({ [blob.type]: blob }),
      ]);
      setCopied('image');
      setTimeout(() => setCopied(null), 1500);
    } catch {
      setCopied(null);
    }
  };

  return (
    <div
      className="chat-image-wrap"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <a
        href={src}
        target="_blank"
        rel="noopener noreferrer"
        className="chat-image-link"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={src} alt={alt} className="chat-message-img max-w-full h-auto rounded-lg" />
      </a>
      <div className={`chat-image-actions ${showActions ? 'visible' : ''}`}>
        <button
          type="button"
          className="chat-image-btn"
          onClick={handleCopyLink}
          title="Copy link"
        >
          <BiLink className="inline" />
          {copied === 'link' ? ' Copied' : ''}
        </button>
        <button
          type="button"
          className="chat-image-btn"
          onClick={handleCopyImage}
          title="Copy image"
        >
          <BiImage className="inline" />
          {copied === 'image' ? ' Copied' : ''}
        </button>
      </div>
    </div>
  );
}
